import { useSelector } from 'react-redux'

import {
  selectCustomEndpoints,
  selectCustomEndpointsFetching,
  selectEntitySets,
  selectEntitySetsSourceId
} from 'redux/selectors/CustomEndpoints'

export const useCustomEndpoints = () => {
  return useSelector(selectCustomEndpoints)
}

export const useCustomEndpointsFetching = () => {
  return useSelector(selectCustomEndpointsFetching)
}

export const useEntitySets = () => {
  return useSelector(selectEntitySets)
}

/** Null until the entity sets for a given source have been fetched. */
export const useEntitySetsSourceId = () => {
  return useSelector(selectEntitySetsSourceId)
}
